import React, { Component } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Row,
  Select,
  Button,
  Form,
  Input,
  Radio,
  Spin,
  Icon,
  Collapse,
  Modal,
  message,
  Typography,
  Tooltip,
  Checkbox
} from 'antd';
import moment from 'moment';

import { PRIORITY_COUNTRIES, OTHER_COUNTRIES } from './DomainsPageConstants';
import {
  getUserStatisticDataById,
  getLoggedUserStatisticData
} from '../../redux/action/user/UserActions';
import {
  getDomainData,
  getLanguages,
  getNoCommercialReasons
} from '../../redux/action/common/CommonActions';
import {
  getWhoIsData,
  getAllDomainsForProcessing,
  checkReservedDomainsIds,
  getDomainImagesCountData,
  saveDomainData,
  changeDomainDataContainer
} from '../../redux/action/domainPage/DomainPageActions';

import './DomainsPage.css';

const { Option } = Select;
const { Panel } = Collapse;
const { Paragraph } = Typography;

class DomainsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mainImageIsLoad: false,
      filledByOperator: false,
      buttonContainerMarginTop: 0,
      buttonContainerMarginBottom: 0,
      domainWorkIndex: 0,
      languageNotIdentified: false,
      countryNotIdentified: false,
      detailsNotIdentified: false,
      isVisibleConfirm: false,
      isVisibleNotIdenticalConfirm: false,
      notSelectedOtherLanguage: true,
      selectAnyCountry: false,
      notSelectedOtherCountry: true,
      selectWebsiteAsCommercial: false,
      selectWebsiteAsNotCommercial: false,
      artShopStatus: false,
      noCommercialReason: '',
      priorityLanguage: '',
      notPriorityLanguage: '',
      priorityLanguageOptions: [],
      notPriorityLanguageOptions: []
    };
  }

  componentDidMount() {
    this.props.getLanguages();
    // this.props
    //   .getLoggedUserStatisticData(
    //     moment().format('YYYY-MM-DD'),
    //     moment().format('YYYY-MM-DD')
    //   )
    //   .then(() => {
    //     setInterval(this.runUserStatisticDataScheduler, 60000);
    //   });
    // this.props.getUserStatisticDataById( this.props.userInfo.userId, moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'))

    this.props.getAllDomainsForProcessing().then(() => {
      if (!_.isEmpty(this.props.allDomainsData)) {
        setInterval(this.checkreservedDomainsIdsByPeriod, 30000);
        for (let i = 0; i < 2; i++) {
          this.getDomainPreparedData(
            this.props.allDomainsData[this.state.domainWorkIndex + i]
          );
        }
      } else {
        message.error(
          {
            content: 'No data. Please contact your system administrator.',
            className: 'custom-class',
            style: {
              marginTop: '20vh'
            }
          },
          0
        );
      }
    });

    this.props.getNoCommercialReasons();

    if (!this.props.userInfo.userPermissions.domainPermission) {
      window.location = '/403';
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    !_.isEqual(prevState.selectAnyCountry, this.state.selectAnyCountry) &&
      this.props.form.validateFields(['priorityCountry'], {
        force: true
      });
  }

  handleRouteTo = (path) => {
    window.location.pathname = path;
  };

  runUserStatisticDataScheduler = () => {
    this.props.getLoggedUserStatisticData(
      moment().format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD')
    );
  };

  checkreservedDomainsIdsByPeriod = () => {
    // this.props.checkreservedDomainsIds(this.props.allDomainsData.join(','))
    this.props.checkReservedDomainsIds(this.props.reservedDomainsIds.join(','));
  };

  getDomainPreparedData = (imageIndex, callback = null) => {
    let domainDataObject = {};

    this.props.getDomainData(imageIndex).then(() => {
      domainDataObject = this.props.domainData;

      this.props.getDomainImagesCountData(imageIndex).then(() => {
        domainDataObject = _.merge({}, domainDataObject, {
          imagesCountOnDomain: this.props.domainImagesCountData.count
        });
        Promise.resolve(
          this.props.changeDomainDataContainer(domainDataObject, null)
        )
          .then(() => {
            callback && callback();
          })
          .then(() => {
            const { domainsWorkData } = this.props;
            const { domainWorkIndex } = this.state;
            const domain =
              domainsWorkData &&
              domainsWorkData[domainWorkIndex] &&
              domainsWorkData[domainWorkIndex].domain;

            this.props.getWhoIsData(domain);
          });
      });
    });
  };

  setFormInitialValues = () => {
    const { form, domainsWorkData } = this.props;
    const { domainWorkIndex } = this.state;
    let fieldValues = {
      website_radio: undefined
    };

    if (domainsWorkData.hasOwnProperty(domainWorkIndex)) {
      _.forEach(Object.keys(domainsWorkData[domainWorkIndex]), (key) => {
        if (
          key === 'commercialWebSite' &&
          domainsWorkData[domainWorkIndex][key] !== null
        ) {
          fieldValues = _.merge({}, fieldValues, {
            website_radio: domainsWorkData[domainWorkIndex][key]
              ? 'commercialWebSite'
              : 'nonCommercial'
          });
        } else if (
          key === 'unsureType' &&
          domainsWorkData[domainWorkIndex][key] !== null
        ) {
          fieldValues = _.merge({}, fieldValues, {
            website_radio: 'unsureType'
          });
        } else {
          fieldValues = _.merge({}, fieldValues, {
            [key]:
              domainsWorkData[domainWorkIndex][key] !== null
                ? domainsWorkData[domainWorkIndex][key]
                : undefined
          });
        }
      });

      let selectWebsiteAsNotCommercial = false;

      if (_.isNil(domainsWorkData[domainWorkIndex].commercialWebSite)) {
        selectWebsiteAsNotCommercial = false;
      } else {
        selectWebsiteAsNotCommercial =
          !domainsWorkData[domainWorkIndex].commercialWebSite;
      }

      this.setState(
        {
          selectWebsiteAsCommercial:
            !!domainsWorkData[domainWorkIndex].commercialWebSite,
          selectWebsiteAsNotCommercial: selectWebsiteAsNotCommercial,
          filledByOperator: !domainsWorkData[domainWorkIndex].filledByOperator
        },
        () => {
          form.setFieldsValue(fieldValues);
        }
      );
    }
  };

  handleNextImageAfterChangePreviousImageStatus = (newValues) => {
    const { domainsWorkData } = this.props;
    const { domainWorkIndex } = this.state;
    let changedDomainsWorkData = _.cloneDeep(domainsWorkData[domainWorkIndex]);
    changedDomainsWorkData = _.merge({}, changedDomainsWorkData, newValues);

    // let changeComment = {
    //   [`img_data_${allDomainsData[domainWorkIndex]}`]: _.cloneDeep(domainsWorkData[`img_data_${allDomainsData[domainWorkIndex]}`]),
    // }
    //
    // changeComment[`img_data_${allDomainsData[domainWorkIndex]}`].imageData.comment = this.props.form.getFieldValue('comment')
    this.props.changeDomainDataContainer(
      changedDomainsWorkData,
      domainWorkIndex
    );
    this.handleMoveButtonClick('next');
  };

  copyToClipboard = (textToCopy) => {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(textToCopy);
    } else {
      let textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      return new Promise((res, rej) => {
        document.execCommand('copy') ? res() : rej();
        textArea.remove();
      });
    }
  };

  handleCopy = (value) => (_event) => {
    this.copyToClipboard(value)
      .then(() => console.log('copied!'))
      .catch((e) => console.log('error: ', e));
  };

  handleDetailsSave = () => {
    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const { allDomainsData, domainsWorkData, reservedDomainsIds } =
        this.props;
      const { domainWorkIndex } = this.state;

      _.forEach(Object.keys(values), (k) => {
        if (values[k] === undefined || values[k] === 'undefined') {
          values[k] = null;
        }
      });

      if (values.website_radio === 'commercialWebSite') {
        values = _.merge({}, values, {
          commercialWebSite: true,
          unsureType: null
        });
      } else if (values.website_radio === 'nonCommercial') {
        values = _.merge({}, values, {
          commercialWebSite: false,
          unsureType: null,
          noCommercialCause: this.state.noCommercialReason
        });
      } else if (values.website_radio === 'unsureType') {
        values = _.merge({}, values, {
          commercialWebSite: null,
          unsureType: true
        });
      } else {
        values = _.merge({}, values, {
          commercialWebSite: null,
          unsureType: null
        });
      }

      values = _.merge({}, values, {
        priorityLanguage: this.state.priorityLanguage || null
      });

      values = _.merge({}, values, {
        otherLanguage: this.state.notPriorityLanguage || null
      });

      this.props
        .saveDomainData(domainsWorkData[domainWorkIndex].id, values)
        .then(() => {
          if (this.props.saveDomainDataErrorMessage) {
            message.error('Server error', 4);
          } else {
            message.success('Domain details saved successfully', 4);

            let reservedDomainsIdsCopy = _.cloneDeep(reservedDomainsIds);
            // let idIndex = _.findIndex(reservedDomainsIdsCopy, allDomainsData[domainWorkIndex])
            let idIndex = reservedDomainsIdsCopy.indexOf(
              allDomainsData[domainWorkIndex]
            );
            idIndex !== -1 && reservedDomainsIdsCopy.splice(idIndex, 1);
            this.props.checkReservedDomainsIds(reservedDomainsIdsCopy);
            this.handleNextImageAfterChangePreviousImageStatus(values);
          }
        });
    });
  };

  handleMoveButtonClick = (action) => {
    this.refs[`${action}_btn`].buttonNode.disabled = true;
    setTimeout(() => {
      this.refs[`${action}_btn`].buttonNode.disabled = false;
    }, 1000);
    const { allDomainsData } = this.props;
    const { domainWorkIndex } = this.state;

    switch (action) {
      case 'prev':
        // LocalStorageService.set('_processing_data', { domainWorkIndex: domainWorkIndex - 1 })
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        this.setState(
          {
            domainWorkIndex: domainWorkIndex - 1,
            mainImageIsLoad: false
          },
          () => {
            this.setFormInitialValues();
            this.getDomainPreparedData(allDomainsData[domainWorkIndex]);

            // this.getDomainPreparedData(allDomainsData[domainWorkIndex - 2], () => {
            //   this.props.changeDomainDataContainer([], domainWorkIndex + 1)
            // })
          }
        );
        break;
      case 'next':
        // LocalStorageService.set('_processing_data', { domainWorkIndex: domainWorkIndex + 1 })
        domainWorkIndex ===
          this.props.allDomainsData.length -
            process.env.REACT_APP_AMOUNT_DOMAINS_PENDING_LIMIT / 2 &&
          this.props.getAllDomainsForProcessing().then(() => {
            for (let i = 0; i < 2; i++) {
              this.getDomainPreparedData(
                this.props.allDomainsData[this.state.domainWorkIndex + i]
              );
            }
          });
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        this.setState(
          {
            domainWorkIndex: domainWorkIndex + 1,
            mainImageIsLoad: false
          },
          () => {
            this.setFormInitialValues();
            this.getDomainPreparedData(allDomainsData[domainWorkIndex + 2]);
          }
        );
        break;
      default:
        break;
    }
  };

  askBeforeSave = () => {
    this.setState(
      {
        isVisibleNotIdenticalConfirm: true
      },
      () => {
        this.renderNotIdenticalConfirmModal();
      }
    );
  };

  renderNotIdenticalConfirmModal = () => {
    const { isVisibleNotIdenticalConfirm } = this.state;

    return Modal.confirm({
      visible: isVisibleNotIdenticalConfirm,
      title: '',
      content: 'Are you sure that images "Not identical"',
      keyboard: false,
      maskClosable: false,
      okText: 'Ok',
      cancelText: 'Cancel',
      onOk: () => this.handleSaveAsNonIdentical(),
      onCancel: () => this.handleClseNotIdenticalConfirm()
    });
  };

  changeOtherLanguage = (value) => {
    this.setState({
      notPriorityLanguage: value
    });
    this.setState(
      {
        notSelectedOtherLanguage: !value
      },
      () => {
        this.props.form.validateFields(['priorityLanguage'], {
          force: true
        });
      }
    );
  };

  handleClseNotIdenticalConfirm = () => {
    this.setState(
      {
        isVisibleNotIdenticalConfirm: false
      },
      () => {
        Modal.destroyAll();
      }
    );
  };

  prepareLanguageOptions = (priority = false) => {
    let sortedLanguages = _.orderBy(this.props.languagesData, 'label', 'asc');
    let languageOptions = _.filter(
      sortedLanguages,
      (lang) => lang.priority === priority
    );

    if (this.state.priorityLanguageOptions.length > 0 && priority) {
      return _.map(this.state.priorityLanguageOptions, (op, index) => (
        <Option value={op.code} key={`${op.code}_${index}`}>
          {op.label}
        </Option>
      ));
    }

    if (this.state.notPriorityLanguageOptions.length > 0 && !priority) {
      return _.map(this.state.notPriorityLanguageOptions, (op, index) => (
        <Option value={op.code} key={`${op.code}_${index}`}>
          {op.label}
        </Option>
      ));
    }

    return _.map(languageOptions, (op, index) => (
      <Option value={op.code} key={`${op.code}_${index}`}>
        {op.label}
      </Option>
    ));
  };

  prepareCountriesOptions = (priority = false) => {
    if (priority) {
      return _.map(PRIORITY_COUNTRIES, (country, index) => (
        <Option value={country.key} key={`${country.key}_${index}`}>
          {country.value}
        </Option>
      ));
    } else {
      return _.map(OTHER_COUNTRIES, (country, index) => (
        <Option value={country.key} key={`${country.key}_${index}`}>
          {country.value}
        </Option>
      ));
    }
  };

  handleChangeWebsiteStatus = (e) => {
    let fieldValues = this.props.form.getFieldsValue();

    if (e.target.value === 'commercialWebSite') {
      this.setState({
        selectWebsiteAsCommercial: true,
        selectWebsiteAsNotCommercial: false
      });
    } else {
      this.setState(
        {
          selectWebsiteAsCommercial: false,
          selectWebsiteAsNotCommercial: true
        },
        () => {
          _.forEach(Object.keys(fieldValues), (key) => {
            if (key === 'website_radio') {
              fieldValues[key] = e.target.value;
            } else if (key !== 'blacklisted' && key !== 'comment') {
              fieldValues[key] = undefined;
            }
          });

          this.props.form.setFieldsValue(fieldValues);
        }
      );
    }
  };

  resetContactDetailsFields = (fieldValues) => {
    _.forEach(Object.keys(fieldValues), (key) => {
      if (
        key === 'street' ||
        key === 'city' ||
        key === 'postcode' ||
        key === 'phoneNumber' ||
        key === 'email' ||
        key === 'noDetailsFound' ||
        key === 'facebookLink' ||
        key === 'contactFormLink'
      ) {
        fieldValues[key] = undefined;
      }
    });

    this.props.form.setFieldsValue(fieldValues);
  };

  changePriorityCountry = (value, fieldValue) => {
    // this.props.form.validateFields(['priorityCountry'], { force: true });
    this.setState({
      notPriorityLanguageOptions: [],
      priorityLanguageOptions: [],
      priorityLanguage: '',
      notPriorityLanguage: ''
    });
    let lang = null;
    let country = null;
    let priorityLangOptions = [];
    let notPriorityLangOptions = [];
    let lowercase = '';
    let capitalizeCase = '';

    if (value) {
      lowercase =
        value !== 'UNITED STATES OF AMERICA' ? value.toLowerCase() : value;
      capitalizeCase =
        lowercase !== 'united kingdom'
          ? lowercase.charAt(0).toUpperCase() + lowercase.slice(1)
          : 'United Kingdom';
    }

    if (fieldValue === 'priorityCountry') {
      country = this.props.form.getFieldValue('otherCountries');
      let sortedLanguages = _.orderBy(this.props.languagesData, 'label', 'asc');
      let languageOptions = _.filter(
        sortedLanguages,
        (lang) => lang.priority === true
      );

      languageOptions.forEach((language) => {
        if (language.countries.includes(capitalizeCase)) {
          lang = language.code;
          priorityLangOptions.push(language);
          this.setState({
            priorityLanguage: language.code
          });
        }
      });

      if (!lang) {
        let languageNotPrioOptions = _.filter(
          sortedLanguages,
          (lang) => lang.priority === false
        );
        languageNotPrioOptions.forEach((language) => {
          if (language.countries.includes(capitalizeCase)) {
            lang = language.code;
            notPriorityLangOptions.push(language);
            this.setState({
              notPriorityLanguage: language.code
            });
          }
        });
      }

      this.setState({
        priorityLanguageOptions: priorityLangOptions,
        notPriorityLanguageOptions: notPriorityLangOptions
      });
    } else {
      country = this.props.form.getFieldValue('priorityCountry');
    }

    this.setState(
      {
        selectAnyCountry: !_.isEmpty(value) || !_.isEmpty(country)
      },
      () => {
        if (!value) {
          if (
            (_.isEmpty(value) && _.isEmpty(country)) ||
            (_.isEmpty(value) && fieldValue === 'priorityCountry')
          ) {
            let fieldValues = this.props.form.getFieldsValue();
            this.resetContactDetailsFields(fieldValues);
          }
        }
      }
    );
  };

  setArtShopStatus = (e) => {
    let fieldValues = this.props.form.getFieldsValue();
    if (fieldValues === 'gallery') {
      this.setState({
        artShopStatus: e.target.checked
      });
    }
  };

  render() {
    const {
      form,
      domainsWorkData,
      allDomainsData,
      whoIsData,
      getNoCommercialReasonsData
    } = this.props;
    const { domainWorkIndex } = this.state;
    const { getFieldDecorator } = form;
    const {
      street,
      city,
      zipcode,
      phone,
      email,
      companyName,
      owlerUrl,
      primaryCountry
    } = !_.isEmpty(whoIsData) && whoIsData;

    if (!_.isEmpty(domainsWorkData) && domainsWorkData.length >= 2) {
      !this.state.mainImageIsLoad &&
        this.setState(
          {
            mainImageIsLoad: true
          },
          () => {
            this.setFormInitialValues();
          }
        );
    }

    return (
      <Spin
        className='spinner-block'
        size='large'
        spinning={_.isEmpty(domainsWorkData) || domainsWorkData.length < 2}
      >
        <div className='DomainsPage'>
          <Row>
            {/* <Form layout="vertical" prefixCls="edit_file_content_"> */}
            <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 d-f-c-sb-fstart m-b-25'>
              <Button.Group size='large' className='prev-next-button-group'>
                <Button
                  ref='prev_btn'
                  className={domainWorkIndex === 0 ? 'hidden' : ''}
                  onClick={() => this.handleMoveButtonClick('prev')}
                >
                  <Icon type='left' />
                  Previous page
                </Button>
                <Button
                  ref='next_btn'
                  className={
                    domainWorkIndex === allDomainsData.length - 1
                      ? 'hidden'
                      : ''
                  }
                  onClick={() => this.handleMoveButtonClick('next')}
                >
                  Next page
                  <Icon type='right' />
                </Button>
              </Button.Group>
            </div>
            {/*<div className="ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 d-f-c-sb-center m-b-25">*/}
            <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 m-b-25'>
              <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-8 ant-col-xl-8'>
                {/*<Spin size="large" spinning={loggedUserStatisticDataIsFetching}>*/}
                {/*</Spin>*/}
              </div>
              {!_.isEmpty(domainsWorkData) && (
                <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-8 ant-col-xl-8 d-f-c-sb-center'>
                  <div className='domain-flexbox'>
                    <h2 style={{ fontSize: '28px' }}>
                      <a
                        target='_blank'
                        rel='nofollow noopener noreferrer'
                        href={`//${domainsWorkData[domainWorkIndex].domain}`}
                      >
                        {domainsWorkData[domainWorkIndex].domain}
                      </a>
                    </h2>
                    <Button
                      type='primary'
                      onClick={this.handleCopy(
                        domainsWorkData[domainWorkIndex].domain
                      )}
                      style={{ marginBottom: 10 }}
                    >
                      Copy
                    </Button>
                  </div>
                  {/*<h3>Domain sightings: {this.props.domainImagesCount}</h3>*/}
                  <h3>
                    Domain sightings:{' '}
                    {domainsWorkData[domainWorkIndex].imagesCountOnDomain}
                  </h3>
                </div>
              )}
              <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-8 ant-col-xl-8' />
            </div>
            <Form layout='vertical' prefixCls='edit_file_content_'>
              <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 detail-form-container m-t-25'>
                <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 d-f-c-sb-center'>
                  <span
                    style={{
                      fontSize: '22px',
                      fontWeight: 600,
                      color: '#000000'
                    }}
                  >
                    Domain details
                  </span>
                </div>
                <div className='ant-col-sm-24 ant-col-md-12 ant-col-lg-8 ant-col-xl-8 d-f-c-sb-fstart m-t-25'>
                  <h2>Website</h2>
                  <Form.Item
                    style={{
                      marginBottom: 5,
                      width: '100%'
                    }}
                  >
                    {getFieldDecorator('website_radio', {
                      rules: [
                        {
                          required: this.state.filledByOperator,
                          message: 'Required field'
                        }
                      ]
                    })(
                      <Radio.Group
                        className='d-f-c-sb-fstart website-radio-group'
                        onChange={this.handleChangeWebsiteStatus}
                      >
                        <Radio
                          value='commercialWebSite'
                          style={{ fontSize: '16px' }}
                        >
                          Commercial
                        </Radio>
                        <Radio
                          value='nonCommercial'
                          style={{ fontSize: '16px' }}
                        >
                          Non-Commercial
                        </Radio>
                        {/*<Radio value="unsureType">Unsure</Radio>*/}
                      </Radio.Group>
                    )}
                  </Form.Item>
                  {this.state.selectWebsiteAsNotCommercial && (
                    <Form.Item
                      style={{
                        marginBottom: 5,
                        width: '80%'
                      }}
                    >
                      {getFieldDecorator('noCommercialCause', {
                        rules: [
                          {
                            required: this.state.selectWebsiteAsNotCommercial,
                            message: 'Reason required'
                          }
                        ]
                      })(
                        <Select
                          allowClear
                          showSearch
                          placeholder='Reason'
                          optionFilterProp='children'
                          onChange={(value) =>
                            this.setState({
                              noCommercialReason: value
                            })
                          }
                        >
                          {!_.isEmpty(getNoCommercialReasonsData) &&
                            _.map(
                              getNoCommercialReasonsData,
                              (reason, index) => (
                                <Option
                                  value={reason}
                                  key={`${reason}_${index}`}
                                >
                                  {reason}
                                </Option>
                              )
                            )}
                        </Select>
                      )}
                    </Form.Item>
                  )}
                  <Form.Item>
                    {getFieldDecorator('gallery', {
                      setFieldsValue: this.state.artShopStatus,
                      valuePropName: 'checked'
                    })(<Checkbox onChange={(e) => this.setArtShopStatus(e)} />)}
                    <span
                      style={{
                        padding: '0 8px',
                        fontSize: '16px'
                      }}
                    >
                      Art shop
                    </span>
                  </Form.Item>
                  {/*<Form.Item style={{ marginBottom: 0, width: '100%' }}>*/}
                  {/*  {getFieldDecorator('blacklisted', {*/}
                  {/*    valuePropName: 'checked',*/}
                  {/*  })(*/}
                  {/*    <Checkbox>*/}
                  {/*      Add to blacklist*/}
                  {/*    </Checkbox>,*/}
                  {/*  )}*/}
                  {/*</Form.Item>*/}
                </div>
                <div className='ant-col-sm-24 ant-col-md-12 ant-col-lg-8 ant-col-xl-8 d-f-c-sb-fstart m-t-25'>
                  <h2>Country</h2>
                  <Form.Item
                    style={{
                      marginBottom: 0,
                      width: '100%'
                    }}
                    className='country-selector'
                  >
                    {getFieldDecorator('priorityCountry', {
                      rules: [
                        {
                          required:
                            this.state.selectWebsiteAsCommercial &&
                            !this.state.selectAnyCountry,
                          message:
                            'Select country from Priority or Other dropdown'
                        }
                      ]
                    })(
                      <Select
                        allowClear
                        showSearch
                        style={{ width: '95%' }}
                        placeholder='Priority'
                        optionFilterProp='children'
                        onChange={(value) =>
                          this.changePriorityCountry(value, 'priorityCountry')
                        }
                        disabled={
                          this.state.countryNotIdentified ||
                          !this.state.selectWebsiteAsCommercial ||
                          form.getFieldValue('otherCountries')
                        }
                      >
                        {this.prepareCountriesOptions(true)}
                      </Select>
                    )}
                  </Form.Item>
                  <Form.Item
                    style={{
                      marginBottom: 0,
                      width: '100%'
                    }}
                  >
                    {getFieldDecorator('otherCountries')(
                      <Select
                        allowClear
                        showSearch
                        style={{ width: '95%' }}
                        placeholder='Other'
                        optionFilterProp='children'
                        onChange={(value) =>
                          this.changePriorityCountry(value, 'otherCountries')
                        }
                        disabled={
                          this.state.countryNotIdentified ||
                          !this.state.selectWebsiteAsCommercial ||
                          form.getFieldValue('priorityCountry')
                        }
                      >
                        {this.prepareCountriesOptions()}
                      </Select>
                    )}
                  </Form.Item>
                </div>

                <div className='ant-col-sm-24 ant-col-md-12 ant-col-lg-8 ant-col-xl-8 d-f-c-sb-fstart m-t-25'>
                  <h2>Language</h2>
                  <Form.Item
                    style={{
                      marginBottom: 0,
                      width: '100%'
                    }}
                  >
                    <Select
                      allowClear
                      showSearch
                      style={{ width: '95%' }}
                      placeholder='Priority'
                      value={this.state.priorityLanguage}
                      onChange={(value) => {
                        this.setState({
                          priorityLanguage: value
                        });
                      }}
                      optionFilterProp='children'
                      disabled={
                        this.state.languageNotIdentified ||
                        !this.state.selectWebsiteAsCommercial
                      }
                    >
                      {this.prepareLanguageOptions(true)}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    style={{
                      marginBottom: 0,
                      width: '100%'
                    }}
                  >
                    <Select
                      allowClear
                      showSearch
                      style={{ width: '95%' }}
                      placeholder='Other'
                      optionFilterProp='children'
                      value={this.state.notPriorityLanguage}
                      disabled={
                        this.state.languageNotIdentified ||
                        !this.state.selectWebsiteAsCommercial
                      }
                      onChange={(value) => this.changeOtherLanguage(value)}
                    >
                      {this.prepareLanguageOptions()}
                      {/*{_.map(OTHER_LANGUAGES, (lang) => (*/}
                      {/*  <Option value={lang.key}>{lang.value}</Option>*/}
                      {/*))}*/}
                    </Select>
                  </Form.Item>
                </div>
                <div
                  className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 d-f-c-sb-fstart m-t-25'
                  // priorityCountry
                  // style={{ display: this.state.selectWebsiteAsCommercial ? 'block' : 'none' }}>
                  style={{
                    display: this.props.form.getFieldValue('priorityCountry')
                      ? 'block'
                      : 'none'
                  }}
                >
                  <h2>Contact details</h2>
                  <Collapse accordion={false} defaultActiveKey={['1']}>
                    <Panel header='Detailed address' key='1'>
                      <div className='ant-col-sm-24 ant-col-md-12 ant-col-lg-12 ant-col-xl-12 d-f-c-sb-center'>
                        {/*<Form.Item style={{ marginBottom: 0, width: '95%' }}>*/}
                        {/*  {getFieldDecorator('countryOfContact')(*/}
                        {/*    <Input style={{ width: '100%' }} placeholder="County" />,*/}
                        {/*  )}*/}
                        {/*</Form.Item>*/}
                        <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
                          <div className='ant-col-sm-24 ant-col-md-12 ant-col-lg-12 ant-col-xl-12 p-r-10'>
                            <Form.Item
                              style={{
                                marginBottom: 0,
                                width: '100%'
                              }}
                            >
                              {getFieldDecorator('street')(
                                <Input
                                  style={{
                                    width: '100%'
                                  }}
                                  placeholder='Street'
                                  disabled={this.state.detailsNotIdentified}
                                />
                              )}
                            </Form.Item>
                          </div>
                          <div className='ant-col-sm-24 ant-col-md-8 ant-col-lg-8 ant-col-xl-8 p-r-10'>
                            <Form.Item
                              style={{
                                marginBottom: 0,
                                width: '100%'
                              }}
                            >
                              {getFieldDecorator('city')(
                                <Input
                                  style={{
                                    width: '100%'
                                  }}
                                  placeholder='City'
                                  disabled={this.state.detailsNotIdentified}
                                />
                              )}
                            </Form.Item>
                          </div>
                          <div className='ant-col-sm-24 ant-col-md-4 ant-col-lg-4 ant-col-xl-4 p-r-10'>
                            <Form.Item
                              style={{
                                marginBottom: 0,
                                width: '100%'
                              }}
                            >
                              {getFieldDecorator('postcode')(
                                <Input
                                  style={{
                                    width: '100%'
                                  }}
                                  placeholder='Postcode'
                                  disabled={this.state.detailsNotIdentified}
                                />
                              )}
                            </Form.Item>
                          </div>
                        </div>
                        <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 p-r-10'>
                          <Form.Item
                            style={{
                              marginBottom: 0,
                              width: '100%'
                            }}
                          >
                            {getFieldDecorator('phoneNumber')(
                              <Input
                                style={{
                                  width: '100%'
                                }}
                                placeholder='Phone number'
                                disabled={this.state.detailsNotIdentified}
                              />
                            )}
                          </Form.Item>
                        </div>
                        <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 p-r-10'>
                          <Form.Item
                            style={{
                              marginBottom: 0,
                              width: '100%'
                            }}
                          >
                            {getFieldDecorator('email')(
                              <Input
                                style={{
                                  width: '100%'
                                }}
                                placeholder='Email'
                                disabled={this.state.detailsNotIdentified}
                              />
                            )}
                          </Form.Item>
                        </div>
                      </div>
                      <div className='ant-col-sm-24 ant-col-md-12 ant-col-lg-12 ant-col-xl-12 d-f-c-sb-center'>
                        <Form.Item
                          style={{
                            marginBottom: 0,
                            width: '95%'
                          }}
                        >
                          {getFieldDecorator('companyName')(
                            <Input
                              style={{
                                width: '100%'
                              }}
                              placeholder='Company name'
                              disabled={this.state.detailsNotIdentified}
                            />
                          )}
                        </Form.Item>
                        <Form.Item
                          style={{
                            marginBottom: 0,
                            width: '95%'
                          }}
                        >
                          {getFieldDecorator('facebookLink')(
                            <Input
                              style={{
                                width: '100%'
                              }}
                              placeholder='Facebook link'
                              disabled={this.state.detailsNotIdentified}
                            />
                          )}
                        </Form.Item>
                        <Form.Item
                          style={{
                            marginBottom: 0,
                            width: '95%'
                          }}
                        >
                          {getFieldDecorator('contactFormLink')(
                            <Input
                              style={{
                                width: '100%'
                              }}
                              placeholder='Link to address details'
                              disabled={this.state.detailsNotIdentified}
                            />
                          )}
                        </Form.Item>
                      </div>
                    </Panel>
                    {!_.isEmpty(whoIsData) && (
                      <Panel header='Third-party data' key='2'>
                        <div className='third-panel'>
                          <div className='left-side-wrapper'>
                            <div className='top-row'>
                              <div className='border-wrapper street'>
                                <Tooltip title='Street'>
                                  {street && (
                                    <Paragraph copyable>{street}</Paragraph>
                                  )}
                                </Tooltip>
                              </div>
                              <div className='border-wrapper city'>
                                <Tooltip title='City'>
                                  {city && (
                                    <Paragraph copyable>{city}</Paragraph>
                                  )}
                                </Tooltip>
                              </div>
                              <div className='border-wrapper post-code'>
                                <Tooltip title='Zipcode'>
                                  {zipcode && (
                                    <Paragraph copyable>{zipcode}</Paragraph>
                                  )}
                                </Tooltip>
                              </div>
                            </div>
                            <div className='border-wrapper phone-number'>
                              <Tooltip title='Phone-number'>
                                {phone && (
                                  <Paragraph copyable>{phone}</Paragraph>
                                )}
                              </Tooltip>
                            </div>
                            <div className='border-wrapper email'>
                              <Tooltip title='Email'>
                                {email && (
                                  <Paragraph copyable>{email}</Paragraph>
                                )}
                              </Tooltip>
                            </div>
                          </div>
                          <div className='right-side-wrapper'>
                            <div className='border-wrapper company-name'>
                              <Tooltip title='Company Name'>
                                {companyName && (
                                  <Paragraph copyable>{companyName}</Paragraph>
                                )}
                              </Tooltip>
                            </div>
                            <div className='border-wrapper owner-url'>
                              <Tooltip title='Owner url'>
                                {owlerUrl && (
                                  <Paragraph copyable>{owlerUrl}</Paragraph>
                                )}
                              </Tooltip>
                            </div>
                            <div className='border-wrapper country'>
                              <Tooltip title='Country'>
                                {primaryCountry && (
                                  <Paragraph copyable>
                                    {primaryCountry}
                                  </Paragraph>
                                )}
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      </Panel>
                    )}
                  </Collapse>
                </div>
                <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 d-f-r-ac-jc m-t-25'>
                  <Button
                    className='btn-default'
                    onClick={() => this.handleDetailsSave()}
                  >
                    SAVE DETAILS
                  </Button>
                </div>
              </div>
            </Form>
          </Row>
        </div>
      </Spin>
    );
  }
}

function mapStateToProps({
  auth,
  userStore,
  qc_frStore,
  domainsStore,
  commonStore
}) {
  return {
    userInfo: auth.userInfo,
    userStatisticData: userStore.userStatisticData,
    userStatisticDataIsFetching: userStore.userStatisticDataIsFetching,
    userStatisticDataErrorMessage: userStore.userStatisticDataErrorMessage,
    loggedUserStatisticData: userStore.loggedUserStatisticData,
    loggedUserStatisticDataIsFetching:
      userStore.loggedUserStatisticDataIsFetching,
    loggedUserStatisticDataErrorMessage:
      userStore.loggedUserStatisticDataErrorMessage,
    imageData: commonStore.imageData,
    domainData: commonStore.domainData,
    languagesData: commonStore.languagesData,
    getNoCommercialReasonsData: commonStore.getNoCommercialReasonsData,
    originImageData: qc_frStore.originImageData,
    originImageHeaderData: qc_frStore.originImageHeaderData,
    downloadedImageData: qc_frStore.downloadedImageData,
    downloadedImageHeaderData: qc_frStore.downloadedImageHeaderData,
    downloadedImageDataErrorMessage: qc_frStore.downloadedImageDataErrorMessage,
    reservedDomainsIds: qc_frStore.reservedDomainsIds,
    whoIsData: domainsStore.whoIsData,
    allDomainsData: domainsStore.allDomainsData,
    allDomainsDataErrorMessage: domainsStore.allDomainsDataErrorMessage,
    saveDomainDataErrorMessage: domainsStore.saveDomainDataErrorMessage,
    domainImagesCountData: domainsStore.domainImagesCountData,
    domainsWorkData: domainsStore.domainsWorkData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDomainImagesCountData: bindActionCreators(
      getDomainImagesCountData,
      dispatch
    ),
    getDomainData: bindActionCreators(getDomainData, dispatch),
    saveDomainData: bindActionCreators(saveDomainData, dispatch),
    getLanguages: bindActionCreators(getLanguages, dispatch),
    getUserStatisticDataById: bindActionCreators(
      getUserStatisticDataById,
      dispatch
    ),
    getLoggedUserStatisticData: bindActionCreators(
      getLoggedUserStatisticData,
      dispatch
    ),

    //
    getAllDomainsForProcessing: bindActionCreators(
      getAllDomainsForProcessing,
      dispatch
    ),
    checkReservedDomainsIds: bindActionCreators(
      checkReservedDomainsIds,
      dispatch
    ),
    changeDomainDataContainer: bindActionCreators(
      changeDomainDataContainer,
      dispatch
    ),
    getWhoIsData: bindActionCreators(getWhoIsData, dispatch),
    getNoCommercialReasons: bindActionCreators(getNoCommercialReasons, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create({ name: 'DomainsPageForm' })(DomainsPage));
